import axios from 'axios';
import auth from '../cognito-auth/cognitoAuth';

export async function getFeedbacksWithFilter(requestBody) {

  var token = auth.auth.getSignInUserSession().getIdToken().jwtToken;

  // TODO: A service should return something being abstract from the chosen transport protocol.
  // So, not a complete axios response, but only the result data.
  return await axios({
    method: "POST",
    url: process.env.VUE_APP_GQLAPI_URL,
    data: {
      query: `
        query getFeedbacksWithFilter { 
          getFeedbacksWithFilter( limit: ${requestBody.limit}, from_index: ${requestBody.from_index}, filter: "${requestBody.filter}", search_word: "${requestBody.search_word}" ) {
            items {
              order_id
              product
              rating
              comment
              customer
              date
              street
              zip
              city
              phone
              mail
              contact_channel
              review_agreement
            }
            count_feedbacks
          }
        }`
    },
    headers: {
      'Authorization': `${token}`,
      'Content-Type': 'application/graphql'        
    }
  });
}